import React, { useEffect, useRef, useState } from 'react';
import { connect } from 'react-redux';

import Text from 'ui/Text';
import ChangeBetPrice from 'features/Betslip/ChangeBetPrice';
import BetSlipInfo from 'features/Betslip/BetSlipInfo';
import {
    detectMobile,
    formatDenmarkCurrency,
    scrollToTop,
} from 'utils/UiHelper';
import {
    BetslipWrapper,
    MaxBetPriceError,
    OverlayWrapper,
} from 'features/Betslip/styled';
import ValidationMessage from 'features/Betslip/ValidationMessage';
import Big9Service from '../../utils/Big9Service';
import Big9ServiceTerminal from '../../utils/Big9ServiceTerminal';
import { Big9GetCombination } from 'utils/Big9GetCombination';
import { NotificationManager } from 'react-notifications';
import {
    changeCombinationPrice,
    clearMarks,
    formattingMarks,
    setCombinationCount,
} from 'components/big9/actions';
import { calculateRows } from 'utils/Big9BetslipHelper';
import { bindActionCreators } from 'redux';
import * as UiActions from 'actions/UiActions';
import { checkUserLoggedStatus } from 'actions/AuthActions';
import { checkSession } from '../../actions/TerminalSessionActions';
import { isToken } from '../../utils/UiHelper';
import useScreens, {
    CREATE_GROUP_SLUG,
    getScreenUrl,
} from '../SpilKlub/screens/useScreens';
import BetslipHeader from 'features/Betslip/BetslipHeader';
import useHistoryItemsCount from 'features/BottomNavigation/useHistoryItemsCount';
import { authHandler } from '../SpilKlub';

export const PRICES = [0.5, 1, 2, 5, 10, 20];

export const MaxBetPriceWarning = ({ maxBetPrice }) => (
    <MaxBetPriceError>
        <Text condensed size="x1" color="#fff" padding="0" align="center">
            Max indsats er {formatDenmarkCurrency(maxBetPrice)} kr.
        </Text>
    </MaxBetPriceError>
);

const Betslip = ({
    outcomes,
    extId,
    clearMarks,
    formattingMarks,
    validState,
    uiActions,
    checkUserLoggedStatus,
    changeCombinationPrice,
    combinationPrice,
    spilklubPoolWithCouponMode,
    disablePoolWithCoupon = () => {},
    setCombinationCount,
    combinationCount,
    innerComponentMode,
    maxBetPrice,
    checkSession,
    isTerminal = false,
    shareFullOpenState = () => {},
}) => {
    const [fullOpen, setFullOpen] = useState(isTerminal);
    const [openPrice, setOpenPrice] = useState(false);
    const [hidePriceComponent, setHidePriceComponent] = useState(true);
    const [hideSlipComponent, setHideSlipComponent] = useState(true);
    const [resultedPrice, setResultedPrice] = useState(1);
    const { refetch: refetchHistoryItemsCount } = useHistoryItemsCount();
    const $body = document.querySelector('body');
    const betslipRef = useRef();
    const { setScreen } = useScreens();
    const [isPendingCoupon, setIsPendingCoupon] = useState(false);

    useEffect(
        () => {
            if (spilklubPoolWithCouponMode) {
                setFullOpen(true);
                setHideSlipComponent(false);
                setHidePriceComponent(true);
                setOpenPrice(false);
            }
        },
        [spilklubPoolWithCouponMode]
    );

    useEffect(
        () => {
            if (openPrice) {
                setHidePriceComponent(false);
            }
            if (!openPrice && !hidePriceComponent) {
                setTimeout(() => {
                    setHidePriceComponent(true);
                }, 200);
            }
        },
        [openPrice]
    );

    useEffect(
        () => {
            if (fullOpen) {
                shareFullOpenState();
                setHideSlipComponent(false);
                if (detectMobile()) $body.style.overflow = 'hidden';
            } else {
                if (detectMobile()) $body.style.removeProperty('overflow');
            }
            if (!fullOpen && !hideSlipComponent) {
                setTimeout(() => {
                    setHideSlipComponent(true);
                }, 200);
            }
        },
        [fullOpen]
    ); // useffects needed for delaying remove components for better transition

    useEffect(
        () => {
            setCombinationCount(
                calculateRows(outcomes, (items) => formattingMarks(items))
            );
        },
        [outcomes]
    );

    useEffect(
        () => {
            const res = combinationCount * combinationPrice;

            setResultedPrice(res);
            if (res > maxBetPrice) {
                setFullOpen(false);
                isTerminal ? setFullOpen(true) : null;
            } else {
                isTerminal ? setFullOpen(true) : null;
            }
        },
        [combinationCount, combinationPrice]
    );

    const selectGroupForCoupon = () => {
        scrollToTop();
        setFullOpen(false);
        setTimeout(() => {
            checkUserLoggedStatus().then((response) => {
                if (response.success) {
                    setScreen(CREATE_GROUP_SLUG);
                } else {
                    disablePoolWithCoupon();
                    authHandler(uiActions, CREATE_GROUP_SLUG, {
                        redirectBackPath: getScreenUrl(CREATE_GROUP_SLUG),
                    });
                }
            });
        }, 200);
    };

    const onSubmit = () => {
        if (spilklubPoolWithCouponMode) {
            return selectGroupForCoupon();
        }
        setIsPendingCoupon(true);
        Big9Service.makeBet(
            extId,
            combinationPrice * 100,
            Big9GetCombination(outcomes),
            combinationCount
        )
            .then((res) => {
                if (!res.success && !res.data) {
                    NotificationManager.error(
                        res.errorMessage || 'Something went wrong'
                    );
                    setIsPendingCoupon(false);
                } else {
                    scrollToTop();
                    setFullOpen(false);
                    window.localStorage.removeItem('BIG9_Coupon');
                    const transId = res.data?.transId || '';
                    setTimeout(() => {
                        const {
                            left,
                            width,
                        } = betslipRef?.current?.getBoundingClientRect();
                        uiActions.showModal('RECEIPT_POPUP', {
                            id: transId,
                            amount: resultedPrice,
                            position: { left, width },
                        });
                        clearMarks();
                        checkUserLoggedStatus();
                        refetchHistoryItemsCount();
                    }, 200);
                    setIsPendingCoupon(false);
                }
            })
            .catch((e) => {
                setIsPendingCoupon(false);
                console.error(e, 'Post error');
            });
    };

    const onSubmitTerminal = () => {
        let token = window.localStorage.getItem('token');

        if (token) {
            Big9ServiceTerminal.makeBetTerminal(
                extId,
                combinationPrice * 100,
                Big9GetCombination(outcomes),
                rows,
                token
            )
                .then((res) => {
                    if (!res.success && !res.data) {
                        NotificationManager.error(
                            res.errorMessage || 'Something went wrong'
                        );
                    } else {
                        scrollToTop();
                        setFullOpen(true);
                        window.localStorage.removeItem('BIG9_Coupon');
                        const transId = res.data?.transId || '';

                        checkSession(window.localStorage.getItem('token'));

                        setTimeout(() => {
                            const {
                                left,
                                width,
                            } = betslipRef?.current?.getBoundingClientRect();
                            uiActions.showModal('RECEIPT_POPUP', {
                                id: transId,
                                amount: resultedPrice,
                                position: { left, width },
                            });
                            clearMarks();
                            checkUserLoggedStatus();
                        }, 200);

                        changeCombinationPrice(PRICES[0]);
                    }
                })
                .catch((e) => {
                    console.error(e, 'Post error');
                });
        } else {
            uiActions.setLoginModalStatus(true);
        }
    };

    const payAndPlay = () => {
        if (!isToken()) {
            Big9ServiceTerminal.makePayAndPlayTerminal(
                extId,
                combinationPrice * 100,
                Big9GetCombination(outcomes),
                rows,
                (res) => {
                    if (!res.success && !res.data) {
                        NotificationManager.error(
                            res.errorMessage || 'Something went wrong'
                        );
                    } else {
                        scrollToTop();
                        //setFullOpen(false);
                        window.localStorage.removeItem('BIG9_Coupon');
                        const transId = res.data?.transId || '';

                        setTimeout(() => {
                            const {
                                left,
                                width,
                            } = betslipRef?.current?.getBoundingClientRect();
                            uiActions.showModal('RECEIPT_POPUP', {
                                id: transId,
                                amount: resultedPrice,
                                position: { left, width },
                            });
                            clearMarks();
                            checkUserLoggedStatus();
                            // location.reload();
                        }, 200);
                        changeCombinationPrice(PRICES[0]);
                    }
                }
            );
        }
    };

    const getContent = () => {
        return !openPrice && !hideSlipComponent ? (
            <BetSlipInfo
                onClear={() => {
                    setFullOpen(isTerminal); // should be false on web !!!
                }}
                onSubmit={isTerminal ? onSubmitTerminal : onSubmit}
                spilklubPoolWithCouponMode={spilklubPoolWithCouponMode}
                payAndPlay={!isToken() ? payAndPlay : () => {}}
                disablePrintBuyButtonTerminal={resultedPrice > maxBetPrice}
                disableBuyButton={
                    isPendingCoupon ||
                    (combinationCount * combinationPrice < 8 &&
                        !spilklubPoolWithCouponMode)
                }
                combinationPrice={combinationCount * combinationPrice}
            />
        ) : !fullOpen && !hidePriceComponent ? (
            <ChangeBetPrice
                prices={PRICES}
                combinationPrice={combinationPrice}
                changePrice={(price) => {
                    changeCombinationPrice(price);

                    isTerminal
                        ? setOpenPrice(false) && setHideSlipComponent(false)
                        : setOpenPrice(false) && setHideSlipComponent(false);

                    (spilklubPoolWithCouponMode &&
                        price * combinationCount <= maxBetPrice) ||
                        (isTerminal &&
                            setTimeout(() => {
                                setFullOpen(true);
                            }, 200));
                }}
            />
        ) : null;
    };

    return (
        <OverlayWrapper
            showOverlay={!isTerminal ? fullOpen || openPrice : null}
            className={isTerminal ? 'terminal' : null}
        >
            <BetslipWrapper
                fullOpen={fullOpen}
                openPrice={openPrice}
                ref={betslipRef}
                className={isTerminal ? 'terminal' : null}
                innerComponentMode={innerComponentMode}
            >
                {fullOpen &&
                    !validState.status &&
                    !spilklubPoolWithCouponMode && (
                        <ValidationMessage message={validState.message} />
                    )}
                {fullOpen &&
                    combinationCount * combinationPrice < 8 &&
                    validState.status && (
                        <ValidationMessage message={validState.message} />
                    )}

                {resultedPrice > maxBetPrice &&
                    !innerComponentMode && (
                        <MaxBetPriceWarning maxBetPrice={maxBetPrice} />
                    )}

                {!innerComponentMode && (
                    <BetslipHeader
                        openBetslipHandler={() => {
                            if (!isTerminal) {
                                if (resultedPrice <= maxBetPrice) {
                                    if (openPrice) {
                                        setOpenPrice(false);
                                        setTimeout(() => {
                                            setFullOpen(!fullOpen);
                                        }, 200);
                                    } else {
                                        if (fullOpen) {
                                            setTimeout(() => {
                                                disablePoolWithCoupon();
                                            }, 200);
                                        }
                                        setFullOpen(!fullOpen);
                                    }
                                }
                            } else {
                                setFullOpen(true);
                            }
                        }}
                        openPriceHandler={(e) => {
                            e.stopPropagation();
                            e.preventDefault();
                            if (fullOpen) {
                                setFullOpen(false);
                                setTimeout(() => {
                                    setOpenPrice(!openPrice);
                                }, 200);
                            } else {
                                setOpenPrice(!openPrice);
                                if (isTerminal) {
                                    setTimeout(() => {
                                        setFullOpen(true);
                                    }, 200);
                                }
                            }
                        }}
                        combinationPrice={combinationPrice}
                        combinationCount={combinationCount}
                        fullOpen={fullOpen}
                        className={isTerminal ? 'terminal' : null}
                    />
                )}
                {getContent()}
            </BetslipWrapper>
            <div />
        </OverlayWrapper>
    );
};

const mapStateToProps = (state) => {
    return {
        outcomes: state.big9.couponData.outcomes,
        extId: state.big9.couponData.extId,
        validState: state.big9.validState,
        combinationPrice: state.big9.couponData.combinationPrice,
        combinationCount: state.big9.couponData.combinationCount,
        maxBetPrice: state.big9.maxBetPrice,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        checkSession: (token) => {
            dispatch(checkSession(token));
        },
        changeCombinationPrice: (price) => {
            dispatch(changeCombinationPrice(price));
        },
        clearMarks: () => {
            dispatch(clearMarks());
        },
        formattingMarks: (marks) => {
            dispatch(formattingMarks(marks));
        },
        uiActions: bindActionCreators(UiActions, dispatch),
        checkUserLoggedStatus: () => dispatch(checkUserLoggedStatus()),
        setCombinationCount: (combinationCount) =>
            dispatch(setCombinationCount(combinationCount)),
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Betslip);
